export const SET_GOOGLE_ADDRESS = 'SET_GOOGLE_ADDRESS';
export const AUTO_SET_GOOGLE_ADDRESS = 'AUTO_SET_GOOGLE_ADDRESS';
export const RESET_GOOGLE_ADDRESS = 'RESET_GOOGLE_ADDRESS';